<div class="container-fluid">
    <section>
        <div>
            <div class="row">
                <div class="col-md-12">
                    <h1>
                        <span jhiTranslate="multi-site-analysis.title">MULTI-SITE ANALYSIS</span>&nbsp;
                        <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
                    </h1>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex align-items-center">
                    <img class="image-icon-sm" src="content/images/search-nurseries.png">
                    <h4 class="pt-1">
                        <span jhiTranslate="single-site-analysis.select-data-text">Select Data for Analysis</span>&nbsp;
                    </h4>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <a href (click)="browseStudy($event)" jhiTranslate="multi-site-analysis.browse-link"></a>&nbsp;
                    <span jhiTranslate="multi-site-analysis.browse-text"></span>
                </div>
            </div>
            <div class="row pt-3" *ngIf="tabs.length">
                <section class="col-md-12">
                    <nav>
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item pe-1" *ngFor="let tab of tabs" role="presentation">
                                <a class="nav-link" role="tab" data-toggle="tab" (click)="setActive(tab.id)"
                                   [routerLink]="['study/' + tab.id]" [routerLinkActive]="['active']"
                                   [queryParams]="{ studyId: tab.id }" queryParamsHandling="merge">
                                    {{ tab.name }}
                                    <i class="fa fa-times close-nav-tab" (click)="closeTab(tab)"></i>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content pe-1">
                            <div *ngFor="let tab of tabs; trackBy: trackId" role="tabpanel"
                                 class="tab-pane container-fluid row p-3" [class.active]="tab.active"
                                 id="study-{{tab.id}}">
                                <jhi-multi-site-study [studyId]="tab.id" [studyName]="tab.name"></jhi-multi-site-study>
                            </div>
                        </div>
                    </nav>
                </section>
            </div>
        </div>
    </section>
</div>
